var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,7l-.29-.71-1-1-.71-.29h-2l-.71,.29-1,1-.29,.71H3v2H12l.29,.71,1,1,.71,.29h2l.71-.29,1-1,.29-.71h3v-2h-3Zm-2,1.59l-.41,.41h-1.17l-.41-.41v-1.17l.41-.41h1.17l.41,.41v1.17Zm-5.29,5.71l-1-1-.71-.29h-2l-.71,.29-1,1-.29,.71H3v2h2l.29,.71,1,1,.71,.29h2l.71-.29,1-1,.29-.71h10v-2H11l-.29-.71Zm-1.71,2.29l-.41,.41h-1.17l-.41-.41v-1.17l.41-.41h1.17l.41,.41v1.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/1770312069/media/icon-filter.cae6d360dfcf4708fac55c3577e878b7.svg";
export { ForwardRef as ReactComponent };